<template>
    <loader v-if="loading" color="ripple" size="150px" style="height: 280px;"></loader>

    <div v-else class="panel-spotfify-playlists">
        <span>{{ playlists.length == 100 ? "TOP "+ playlists.length : playlists.length }} Playlists including this song </span><br>
        <span>  ordered by followers <i v-show="playlists.length >= 223120" class="iconify" data-icon="zmdi:info" data-height="18" data-inline="true" data-hover="tooltipster" title="Only playlists with at least 5 followers are listed." style="vertical-align: -0.30em;"></i></span><br><br>

        <div v-if="!loading" class="playlists">
            <a href="#" class="playlist" v-for="(p, i) in playlists" target="_new">
                <div class="name" :title="p.name">{{ p.name }}</div>
                <div class="followers">{{ p.followers_count.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }}</div>
            </a>

            <div v-if="!playlists.length">
                <br><br><br><br><span>We couldn't find any playlists<br> for this song.</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['song'],

    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    data() {
        return {
            loading: true,
            spotify_id: null,
            playlists: []
        }
    },

    mounted() {
        var res = this.song.video_providers.spotify.split("/");
        res = res[res.length - 1].split("?");
        this.spotify_id = res[0];
        

        this.$http.get(this.playlistsEndpoint).then((success) => {
            if (Array.isArray(success.data)){
                this.playlists = success.data;
            }
          
            this.loading = false;
            this.$parent.playlistsLoaded = true;
        }, (error) => {
            this.loading = false;
        });      
    },

    computed: {
        playlistsEndpoint() {
            return `https://spotify-collector.soundfeedapp.com/songs/${this.spotify_id}/playlists`;
        },
    },
}
</script>